import { Avatar, Chip, TableCell } from '@mui/material'
import { User } from '../../store/types'
import { generatePath, useNavigate } from 'react-router-dom'
import navigation from '../../config/navigation'
import React from 'react'
import { useAppSelector } from '../../store/redux/hooks'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { getImageSrc } from '../../store/utils'

const EmployeeDistributionHeaderTableCell = ({
  onRemoveIconClick,
  user,
  isEditionDisabled,
}: {
  onRemoveIconClick: () => void
  isEditionDisabled: boolean
  user: User
}) => {
  const navigate = useNavigate()
  const currentUser = useAppSelector(state => getCurrentUser(state))
  const handleChipClick = (event: React.MouseEvent) => {
    const chipLabel = event.currentTarget.querySelector('.MuiChip-label')
    const chipAvatar = event.currentTarget.querySelector('.MuiAvatar-root')

    if (chipLabel && chipLabel.contains(event.target as Node)) {
      navigate(generatePath(navigation.userProfile, { id: user.id }))
    } else if (chipAvatar && chipAvatar.contains(event.target as Node)) {
      navigate(generatePath(navigation.userProfile, { id: user.id }))
    }
  }
  return (
    <TableCell align="center" sx={{ borderBottom: '1px solid', borderColor: 'background.elevation8' }}>
      <Chip
        color="default"
        label={`${user.firstName} ${user.lastName}`}
        onClick={handleChipClick}
        onDelete={!isEditionDisabled ? onRemoveIconClick : undefined}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(generatePath(navigation.userProfile, { id: user.id }))
          }
        }}
        size="small"
        avatar={
          <Avatar
            src={
              currentUser?.id !== user.id
                ? getImageSrc(user.avatar, user.extension)
                : getImageSrc(currentUser?.avatar, currentUser?.extension)
            }
            alt={`${user.firstName}-${user.lastName}-resourcing-avatar`}
            sx={{ backgroundColor: 'background.elevation8' }}
          />
        }
        variant="outlined"
        sx={{
          '& .MuiChip-avatarSmall': {
            fontSize: '0.70rem',
          },
          '.MuiChip-label': { p: 0, mx: 1 },
          '& .MuiChip-deleteIcon': {
            visibility: 'hidden',
          },
          '&:hover': {
            '& .MuiChip-deleteIcon': {
              visibility: isEditionDisabled ? 'hidden' : 'visible',
            },
          },
          ':focus': {
            '& .MuiChip-deleteIcon': {
              visibility: isEditionDisabled ? 'hidden' : 'visible',
            },
          },
        }}
      />
    </TableCell>
  )
}

export default EmployeeDistributionHeaderTableCell